var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRejectCall(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 16 16",
    style: {
      enableBackground: "new 0 0 16 16"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M13.9,13.5c-0.1,0-0.2,0-0.3-0.1c-0.9-0.7-1.9-1.2-3-1.5c-0.1,0-0.2-0.1-0.3-0.2c-0.1-0.1-0.1-0.3,0-0.4 l0.6-1.9C9,8.9,7,8.9,5.1,9.4l0.6,1.9c0,0.1,0,0.3,0,0.4s-0.2,0.2-0.3,0.2c-1.1,0.3-2.1,0.8-3,1.5c-0.2,0.2-0.5,0.1-0.7-0.1 l-1.6-1.9C0,11.4,0,11.2,0,11.1c0-0.1,0.1-0.3,0.2-0.3C2.4,9,5.2,8,8,8c2.8,0,5.6,1,7.8,2.7c0.1,0.1,0.2,0.2,0.2,0.3 c0,0.1,0,0.3-0.1,0.4l-1.6,1.9C14.2,13.5,14,13.5,13.9,13.5z M1.2,11.2l1,1.1c0.8-0.5,1.6-1,2.4-1.3L4.2,9.7 C3.1,10,2.1,10.5,1.2,11.2z M11.4,11.1c0.9,0.3,1.7,0.7,2.4,1.3l1-1.1c-0.9-0.7-1.9-1.2-2.9-1.6L11.4,11.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M3.5,6C3.2,6,3,5.8,3,5.5v-3C3,2.2,3.2,2,3.5,2h3C6.8,2,7,2.2,7,2.5S6.8,3,6.5,3H4v2.5C4,5.8,3.8,6,3.5,6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M7.5,7C7.4,7,7.2,7,7.1,6.9l-4-4C3,2.7,3,2.3,3.1,2.1s0.5-0.2,0.7,0l3.7,3.7l4.7-3.7c0.2-0.2,0.5-0.1,0.7,0.1 c0.2,0.2,0.1,0.5-0.1,0.7l-5,4C7.7,7,7.6,7,7.5,7z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRejectCall);
export default __webpack_public_path__ + "static/media/reject-call.2521592784b145b5b1efd5d3b3405dc9.svg";
export { ForwardRef as ReactComponent };